import { HttpError } from 'react-admin';

export default async function fetchJSON(url, options) {
  const res = await fetch(url, options);
  if (!res.ok) {
    const resBody = await res.text();
    throw new HttpError(`fetch ${url} returned ${res.status} ${resBody}`, res.status, resBody);
  }
  const resContentType = res.headers.get('content-type');
  if (resContentType && resContentType.indexOf('application/json') === 0) {
    return res.json();
  }
  return res.text();
}



// WEBPACK FOOTER //
// ./src/fetchJSON.js